import type * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { Pill } from '../../../web/components-v2/Pill';
import { tierPillColor, verdictDisplay } from './scoreboardMetrics';
import { styleSheet } from './scoreboard.styles';

interface IProps {
	judgment: Api.ICoachingAdherenceJudgment;
}

export function ScoreboardCallThreads({ judgment }: IProps) {
	const threads = judgment.threads ?? [];

	return (
		<div className={css(styleSheet.threads)}>
			{threads.length > 0 ? (
				<table className={css(styleSheet.threadTable)}>
					<thead>
						<tr>
							<th className={css(styleSheet.threadHeader)}>Coach said</th>
							<th className={css(styleSheet.threadHeader)}>Rep said next</th>
							<th className={css(styleSheet.threadHeader)}>Used it?</th>
						</tr>
					</thead>
					<tbody>
						{threads.map((thread, index) => {
							const verdict = verdictDisplay(thread.verdict);
							return (
								<tr key={`${thread.move ?? 'thread'}-${index}`}>
									<td className={css(styleSheet.threadCell)}>{thread.coachSaid || 'Not recorded'}</td>
									<td className={css(styleSheet.threadCell)}>{thread.whatTheRepDid || 'Not recorded'}</td>
									<td className={css(styleSheet.threadCell)} title={thread.detailMissed ?? undefined}>
										<Pill variant='tag' size='small' color={tierPillColor(verdict.tier)} label={verdict.label} />
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			) : (
				<p className={css(styleSheet.judgmentNote)}>The judge found no coach cards to weigh on this call.</p>
			)}
			{judgment.strength ? (
				<p className={css(styleSheet.judgmentNote)}>
					<span className={css(styleSheet.judgmentNoteLabel)}>Strength: </span>
					{judgment.strength}
				</p>
			) : null}
			{judgment.coachingPoint ? (
				<p className={css(styleSheet.judgmentNote)}>
					<span className={css(styleSheet.judgmentNoteLabel)}>Coaching point: </span>
					{judgment.coachingPoint}
				</p>
			) : null}
		</div>
	);
}
